export default "__VITE_ASSET__CHWSv$IX__"